import React, { useCallback, useEffect, useState } from 'react';
import { LobbyWidget, Timer, Text } from '@betty/moonlight';
import { memo } from 'react';
import { useTranslation } from '@betty/i18n';
import { BottomSheet } from '@betty/navigation';
import useDailyGift from '../../hooks/useDailyGift';
import { useDispatch } from '@betty/toolkit/state';
import { fetchDailyGift } from '../../state/dailyGift.slice';

function DailyGiftWidget() {
  const dispatch = useDispatch();

  const [t] = useTranslation('dailyGift');
  const { dailyGift, dailyGiftStatus } = useDailyGift();

  const showWidget = dailyGift && dailyGiftStatus !== 'NotAvailable';

  const handleClick = () => {
    if (showWidget) {
      BottomSheet.open({
        namespace: 'dailyGift',
        type: 'default',
        light: true,
      });
    }
  };

  const [timeEnded, setTimeEnded] = useState(true);
  const [timerLabel, setTimerLabel] = useState<string | null>(null);

  const onTimeEnded = useCallback(() => {
    setTimeEnded(true);
    setTimerLabel('Claim now');
    dispatch(fetchDailyGift());
  }, [dispatch]);

  useEffect(() => {
    switch (dailyGiftStatus) {
      case 'Awarded':
        setTimerLabel('Claim in');
        setTimeEnded(false);
        break;
      case 'Pending':
        setTimerLabel('Claim now');
        setTimeEnded(true);
        break;
    }
  }, [dailyGiftStatus]);

  const timerComponent = (
    <>
      <Text variant="caption-semi" color="darkSurfacePrimary">
        {timerLabel}
      </Text>
      {!timeEnded && dailyGift?.nextAvailableAt && (
        <Timer
          color="darkSurfacePrimary"
          variant="caption-semi"
          time={dailyGift.nextAvailableAt}
          onCountDownComplete={onTimeEnded}
          displayMode="condensed"
        />
      )}
    </>
  );

  return showWidget ? (
    <LobbyWidget
      image="common.BettyCoinStack"
      label={t('widgetLabel')}
      onClick={handleClick}
      timer={timerComponent}
      hasUnread={timeEnded}
    />
  ) : null;
}

export default memo(DailyGiftWidget);
